<template>
    <div class="container">
        <div class="common-header-wrap">
            <mt-header :title="$t('Contact us')" class="common-header">
                <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
            </mt-header>
        </div>

        <div class="email-list">
            <!-- <index-manage-item v-on:onclick="getEmail" :src="require('../../../assets/image/email.svg')" :title="email_to"
                :isCopy="true">
            </index-manage-item> -->

            <div class="item button" @click="getEmail">
                <div class="l">
                    <div class="icon">
                        <img src="../../../assets/image/home/email.png" alt="email">
                    </div>
                </div>
                <div class="r">
                    <div class="t">{{ email_to }}</div>
                    <div class="copy ds-button" @click.stop="copySuccess(email_to)">{{ $t('Copy') }}</div>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
import IndexManageItem from '../index/IndexManageItem'
import { getCommissionList, getCommissionInfo, send_to_predeposit } from '../../../api/memberInviter'
import { getMemberIndex, boxList, giftList, get_config } from '../../../api/member'
import EmptyRecord from '../../../components/EmptyRecord'
import { Toast, Indicator, MessageBox } from 'mint-ui'
export default {
    name: 'MemberInviterUser',
    components: {
        EmptyRecord,
        IndexManageItem
    },
    data() {
        return {
            params: {
                'page': 0,
                'limit': 10,
                // 'date': this.utils.formatDate_(new Date),
                'date': '',
                'type': 'recovery_gift_parent',
            },
            loading: false, // 是否加载更多
            isMore: true, // 是否有更多
            userList: false,
            type: this.$route.query.type ? this.$route.query.type : 0,
            pickerValue: '',
            endDate: '',
            endDate_: new Date(),
            value: '',
            tabs: [
                // {
                //     gc_name: 'commission',
                //     type: '',
                // },
                {
                    gc_name: 'Direct',
                    type: 'recovery_gift_parent',
                },
                {
                    gc_name: 'Indirect',
                    type: 'recovery_gift_parent_2',
                },
                {
                    gc_name: 'transfer',
                    type: '',
                },
            ],
            activeTab: this.$route.query.indexe ? this.$route.query.indexe : 0,
            info: null,
            email_to: ''
        }
    },
    created() {
        get_config().then(res => {
            if (res.code == 10000) {
                this.email_to = res.data.email
            }
        })
    },

    mounted() {
        window.scrollTo(0, 0);
    },
    methods: {
        scrollToTop() {
            console.log('Scrolling to top...');
            window.scrollTo(0, 0);
            console.log('Current scroll position:', window.scrollY); // 或者使用 document.documentElement.scrollTop
        },
        copySuccess(sn) {
            this.$copyText(sn).then(
                (e) => {
                    Toast(this.$t('succ'))
                    // console.log(e);
                }, (e) => {
                    Toast(this.$t('err'))
                    // console.log(e);
                }
            );
        },
        getEmail() {
            // 设置mailto链接，可以包含收件人、主题和正文
            const to = this.email_to;
            console.log(to);
            // 构建完整的mailto链接
            const mailtoLink = `mailto:${to}`;
            // 触发跳转
            window.location.href = mailtoLink;
        },
        transfer() {
            // this.$router.push({ name: 'MemberWithdrawList' })
            // return
            let that = this
            MessageBox({
                title: that.$t('MessageBox.Tips'),
                message: that.$t('MessageBox.Confirm') + ' ' + that.$t('transfer') + '?',
                confirmButtonText: that.$t('MessageBox.Confirm'),
                cancelButtonText: that.$t('MessageBox.Cancel'),
                showCancelButton: true
            }).then(action => {
                if (action == 'confirm') {
                    send_to_predeposit().then(res => {
                        if (res.code == 10000) {
                            Toast(res.message)
                            that.getInfo()
                            this.getUserList(false)
                        } else {
                            Toast(res.message)
                        }
                    }).catch(function (error) {
                        Toast(error.message)
                    })
                }
            }).catch(() => { })
        },
        tabClick(item, index) {
            this.activeTab = index

            if (index == 0) {
                this.params.type = 'recovery_gift_parent'
            } else if (index == 1) {
                this.params.type = 'recovery_gift_parent_2'
            } else {
                this.params.type = 'down_share_price'
            }

            this.getUserList(false)
        },
        getInfo(date = '') {
            getCommissionInfo(date).then(res => {
                if (res.code == 10000) {
                    this.info = res.result
                }
            })
        },
        getUserList(ispush) {
            Indicator.open()
            let params = this.params
            if (!ispush) {
                params.page = 1
            }
            getCommissionList(params).then(res => {
                Indicator.close()
                if (res.code == 10000) {
                    if (ispush && this.userList) {
                        this.userList = this.userList.concat(res.result.data)
                    } else {
                        this.userList = res.result.data
                    }
                    if (res.result.current_page < res.result.last_page) {
                        this.isMore = true
                    } else {
                        this.isMore = false
                    }
                }
            })
        },
        loadMore() {
            this.loading = true
            this.params.page = ++this.params.page
            if (this.isMore) {
                this.loading = false
                this.getUserList(true)
            }
        },
        //打开时间选择器
        openPicker() {// 如果已经选过日期，则再次打开时间选择器时，日期回显（不需要回显的话可以去掉 这个判断）
            if (this.endDate) {
                this.pickerValue = this.endDate
            } else {
                this.pickerValue = new Date()
            }

            this.$refs.picker.open()
        },
        //时间选择器选中
        changeTime(value) {
            console.log(this.utils.formatDate_(value, 'yyyy-MM-dd'));		//自带的value就是选中的时间
            let date = this.utils.formatDate_(value, 'yyyy-MM-dd')
            this.params.date = date
            this.userList = []
            this.getUserList(false)
            this.getInfo(date)

            this.endDate = value
        },
    }
}
</script>
  
<style scoped lang="scss">
.container {
    background: #fff;
    min-height: 100vh;

    .common-header {
        box-shadow: none;
    }
}

.email-list {
    margin: 1rem;

    .item {
        padding: 1rem .6rem;
        background: #FAFAFA;
        border-radius: 10px 10px 10px 10px;
        display: flex;
        align-items: center;

        .l {
            width: 2rem;
            height: 2rem;
            margin-right: .4rem;

            img {
                width: 100%;
                height: 100%;
                display: block;
            }
        }

        .r {
            .t {
                font-weight: 600;
                font-size: .7rem;
                color: #000000;
            }

            .copy {
                padding: .2rem .6rem;
                display: inline-block;
                font-size: .6rem;
                color: #fff;
                background: #E7010C;
                border-radius: 10px 10px 10px 10px;
            }
        }
    }
}
</style>
  